import { memo } from "react";
import PropTypes from "prop-types";
import RelativeLink from "app/pages/.shared/RelativeLink";
import { FormattedMessage } from "react-intl";
import { IconHelp, IconLuggage } from "app/pages/.shared/static/icons";
import { sendTagOnMenuGoToSearchBooking } from "app/utils/analytics";
import DotNotification from "app/pages/.shared/DotNotification/DotNotification";
import "./AccountAsideMenuUnauthenticated.scss";
import { isEmpty } from "lodash";

const AccountAsideMenuUnauthenticated = ({
	onItemClick = () => {},
	showCustomerRequestNotification = false,
	myBooking = {},
}) => {
	return (
		<div
			className="account-aside-menu-unauthenticated"
			data-testid="account-aside-menu-unauthenticated"
		>
			<div className="account-aside-menu-unauthenticated__body">
				{!isEmpty(myBooking) ? (
					<>
						<div className="account-aside-menu-unauthenticated__list">
							<div className="account-aside-menu-unauthenticated__item">
								<IconLuggage height={20} width={20} />
								<FormattedMessage id="menu.item.my.bookings" tagName="h4" />
							</div>
							<div className="account-aside-menu-unauthenticated__items">
								<RelativeLink
									className="account-aside-menu-unauthenticated__sub-item"
									activeClassName="account-aside-menu-unauthenticated__item--active"
									to={{
										pathname: `/account/mybookings/${
											myBooking.bookingReference
										}`,
									}}
									rel="noopener noreferrer"
									onClick={onItemClick}
									data-testid="go-to-my-booking-link"
								>
									<FormattedMessage
										id="menu.item.my.booking"
										values={{
											bookingReference: myBooking.bookingReference,
										}}
									/>
								</RelativeLink>
								<RelativeLink
									className="account-aside-menu-unauthenticated__sub-item"
									activeClassName="account-aside-menu-unauthenticated__item--active"
									to={{ pathname: "/booking-search" }}
									rel="noopener noreferrer"
									onClick={() => {
										sendTagOnMenuGoToSearchBooking();
										onItemClick();
									}}
									data-testid="go-to-booking-search-link"
								>
									<FormattedMessage id="menu.mobile.go.to.other.bookings" />
								</RelativeLink>
							</div>
						</div>
						<div className="account-aside-menu-unauthenticated__list">
							<div className="account-aside-menu-unauthenticated__item">
								<IconHelp height={20} width={20} />
								<FormattedMessage id="menu.item.need.help" tagName="h4" />
							</div>
							<div className="account-aside-menu-unauthenticated__items">
								<RelativeLink
									className="account-aside-menu-unauthenticated__sub-item"
									activeClassName="account-aside-menu-unauthenticated__item--active"
									to={{ pathname: "/account/faq-contact" }}
									data-testid="account-aside-menu-unauthenticated-help-item"
									onClick={onItemClick}
								>
									<FormattedMessage id="menu.item.faq.contact" />
								</RelativeLink>
								<RelativeLink
									className="account-aside-menu-unauthenticated__sub-item"
									activeClassName="account-aside-menu-unauthenticated__item--active"
									to={{
										pathname: "/account/customer-request/my-requests",
										search: `?bookingReference=${myBooking.bookingReference}`,
									}}
									rel="noopener noreferrer"
									data-testid="account-aside-menu-unauthenticated-my-requests-item"
									onClick={onItemClick}
								>
									<FormattedMessage id="menu.item.my.requests" />
									{showCustomerRequestNotification && <DotNotification />}
								</RelativeLink>
							</div>
						</div>
					</>
				) : (
					<>
						<RelativeLink
							className="account-aside-menu-unauthenticated__item"
							activeClassName="account-aside-menu-unauthenticated__item--active"
							to={{ pathname: "/faq" }}
							rel="noopener noreferrer"
							target="_blank"
							data-testid="account-aside-menu-unauthenticated-help-item"
							onClick={onItemClick}
						>
							<IconHelp height={20} width={20} />
							<FormattedMessage id="menu.item.help" />
						</RelativeLink>
						<RelativeLink
							className="account-aside-menu-unauthenticated__item"
							activeClassName="account-aside-menu-unauthenticated__item--active"
							to={{ pathname: "/booking-search" }}
							rel="noopener noreferrer"
							onClick={() => {
								sendTagOnMenuGoToSearchBooking();
								onItemClick();
							}}
							data-testid="go-to-booking-search-link"
						>
							<IconLuggage height={20} width={20} />
							<FormattedMessage id="menu.mobile.go.to.my.bookings" tagName="h4" />
						</RelativeLink>
					</>
				)}
			</div>
		</div>
	);
};

AccountAsideMenuUnauthenticated.propTypes = {
	onItemClick: PropTypes.func,
	showCustomerRequestNotification: PropTypes.bool,
	myBooking: PropTypes.object,
};

export default memo(AccountAsideMenuUnauthenticated);
